import React from "react";

//components:
import WarningRoundedIcon from "@material-ui/icons/WarningRounded";
import {VideosSearchSlide, SimpleVideoSlide} from "../index";
import {Swiper, SwiperSlide} from "swiper/react";
import SwiperCore, {Navigation, Pagination, Scrollbar, A11y, Autoplay} from "swiper";
SwiperCore.use([Navigation, Pagination, Scrollbar, A11y, Autoplay]);

export const Carousel = ({
    type = "",
    titleClassName = "",
    htmlTagTitle = "",
    spaceBetween = 10,
    data = {
        id: "",
        name: "",
        title: "",
        description: "",
        image_url: "",
        visbleTitle: 1,
    },
    onclick,
    query = "",
    errorMessage = "",
}) => {
    const getItemsFormat = (type, item) => {
        switch (type) {
            case "video-card":
                return (
                    <VideosSearchSlide
                        handleMatchClick={onclick}
                        video={item}
                        className="movieShowcase__container--movie-image"
                        query={query}
                    />
                );
            case "simple-video-card":
                return <SimpleVideoSlide video={item} onclick={onclick} />;

            default:
                return "none";
        }
    };

    return (
        <>
            {htmlTagTitle ? (
                <h3
                    className={`${titleClassName}`}
                    dangerouslySetInnerHTML={{
                        __html: htmlTagTitle,
                    }}
                />
            ) : null}
            {errorMessage ? (
                <div className="alert alert-light font-weight-bold w-fit-content d-flex align-items-center">
                    <WarningRoundedIcon color="inherit" className="mr-5" /> {errorMessage}
                </div>
            ) : null}
            <div className="custom-slide">
                <Swiper
                    className="movieShowcase__container col-12"
                    navigation={true}
                    grabCursor={false}
                    draggable={false}
                    loop={false}
                    spaceBetween={spaceBetween}
                    slidesPerView={"auto"}
                    watchOverflow={true}
                    centeredSlides={false}
                    preventClicksPropagation={true}
                    preventClicks={true}
                    scrollbar={false}
                    slideToClickedSlide={true}
                    loopFillGroupWithBlank={false}
                    breakpoints={{
                        1378: {
                            slidesPerView: 4,
                            slidesPerGroup: 1,
                        },
                        600: {
                            slidesPerView: 3,
                            slidesPerGroup: 1,
                        },
                        0: {
                            slidesPerView: 2,
                            slidesPerGroup: 1,
                        },
                    }}
                >
                    {data.length
                        ? data.map((item, i) => (
                              <SwiperSlide key={i} className="movieShowcase__container--movie__netflix">
                                  {getItemsFormat(type, item)}
                              </SwiperSlide>
                          ))
                        : null}
                </Swiper>
            </div>
        </>
    );
};
